import { wagerAtoms } from './wagerAtoms';
var setWagerElement = function (value) {
    wagerAtoms.wagerElement.setValue(value);
};
export { setWagerElement };
